import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=6671256c&"
import script from "./AppLink.vue?vue&type=script&lang=js&"
export * from "./AppLink.vue?vue&type=script&lang=js&"
import style0 from "./AppLink.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/AppLink.vue
// module id = 1753
// module chunks = 0